import { Store } from '@tanstack/react-store'

export type BreakdownViewtype = 'criteria' | 'employees' | 'teams'

export const selectedBreakdownViewStore = new Store<BreakdownViewtype>(
  'criteria',
)
